import React from 'react';

import { naturalDateRange, parseISO } from '../../../../utils/date-utils';

import { t } from '../../../../locales/i18n';
import { QSContainer, QSPanelPrimary, QSPanelAction, QSPanelCalExceptions } from './layout-components';
import { Button } from 'semantic-ui-react';
import { CalendarException } from '../../../../types/calendar-exception';

function timeIsEmpty(val: string | null | undefined) {
  return val && (val.trim() === '' || val === 'Invalid date');
}

interface OpeningHoursProps {
  from: string | null;
  to: string | null;
}

function OpeningHours({ from, to }: OpeningHoursProps) {
  if (timeIsEmpty(from) && timeIsEmpty(to)) {
    return <span>{t('calException.closed')}</span>;
  }
  let fromStr = from;
  let toStr = to;
  if (timeIsEmpty(from)) {
    fromStr = '00:00';
  }
  if (timeIsEmpty(to)) {
    toStr = '00:00';
  }
  return (
    <span>
      <span>{t('calException.open')}</span>
      <span>{fromStr}</span>-<span>{toStr}</span>
    </span>
  );
}

interface CalExceptionProps {
  calendarException: CalendarException;
  onDelete: (calendarException: CalendarException) => void;
}

export function CalException(props: CalExceptionProps) {
  const { calendarException, onDelete } = props;
  return (
    <QSContainer>
      <QSPanelPrimary>
        {naturalDateRange(parseISO(calendarException.validFrom), parseISO(calendarException.validTo))}
      </QSPanelPrimary>
      <QSPanelCalExceptions>
        <OpeningHours from={calendarException.from} to={calendarException.to} />
      </QSPanelCalExceptions>
      <QSPanelAction>
        <Button icon="close" circular negative basic size="small" onClick={() => onDelete(props.calendarException)} />
      </QSPanelAction>
    </QSContainer>
  );
}
